/*
* プロジェクトフォーム: 組合型によって金額設定を変更
*/
export default class PartnershipType {
  constructor() {
    this.$tk = document.getElementById('standard_project_partnership_type_tk') || document.getElementById('transfer_project_partnership_type_tk');
    this.$nk = document.getElementById('standard_project_partnership_type_nk') || document.getElementById('transfer_project_partnership_type_nk');
    this.$amountForm = document.getElementById('amountForm');
    this.$dividendMonthForm = document.getElementById('dividendMonthForm');
    this.$distributionScheduleForm = document.getElementById('distributionScheduleForm');
    this.$unionMemberForm = document.getElementById('unionMemberForm');
    this.$upfrontFeeRateForm = document.getElementById('upfrontFeeRateForm');
    this.$totalAmountLabel = document.getElementById('totalAmountLabel');
    this.$numberOfUnitsLabel = document.getElementById('numberOfUnitsLabel');
    this.$subordinatedRows = document.querySelectorAll('[data-target="subordinatedRow"]');
  }

  attachEvent() {
    const tk = this.$tk;
    const nk = this.$nk;
    const amountForm = this.$amountForm;
    const dividendMonthForm = this.$dividendMonthForm;
    const distributionScheduleForm = this.$distributionScheduleForm;
    const unionMemberForm = this.$unionMemberForm;
    const upfrontFeeRateForm = this.$upfrontFeeRateForm;
    const totalAmountLabel = this.$totalAmountLabel;
    const numberOfUnitsLabel = this.$numberOfUnitsLabel;
    const subordinatedRows = this.$subordinatedRows;

    const tkTotalAmountLabelText = '優先＋劣後合計金額';
    const nkTotalAmountLabelText = '募集金額';
    const tkNumberOfUnitsLabelText = '優先出資口数';
    const nkNumberOfUnitsLabelText = '募集口数';

    if (!(tk === null || nk === null)) {
      window.addEventListener('pageshow', selectPartnershipType);
      tk.addEventListener('change', selectPartnershipType);
      nk.addEventListener('change', selectPartnershipType);
    }

    function selectPartnershipType() {
      if (tk.checked) {
        // TK(匿名組合)の場合: 優先・劣後出資それぞれの出資口数と金額のフォームを表示
        showTkFields();
      } else if (nk.checked) {
        // NK(任意組合)の場合: 募集口数と金額のフォームを表示
        showNkFields();
      } else {
        // どちらも選択していない場合: 金額設定フォームを非表示
        hideAmountForm();
        hide(unionMemberForm);
        hide(dividendMonthForm);
        hide(upfrontFeeRateForm);
      }
    }

    function showTkFields() {
      show(amountForm);
      show(distributionScheduleForm);
      show(upfrontFeeRateForm);
      hide(dividendMonthForm);
      hide(unionMemberForm);
      subordinatedRows.forEach(row => show(row));
      totalAmountLabel.textContent = tkTotalAmountLabelText;
      numberOfUnitsLabel.textContent = tkNumberOfUnitsLabelText;
    }

    function showNkFields() {
      show(amountForm);
      show(dividendMonthForm);
      show(unionMemberForm);
      hide(distributionScheduleForm);
      hide(upfrontFeeRateForm);
      subordinatedRows.forEach(row => hide(row));
      totalAmountLabel.textContent = nkTotalAmountLabelText;
      numberOfUnitsLabel.textContent = nkNumberOfUnitsLabelText;
    }

    function hideAmountForm() {
      hide(amountForm);
    }

    function show(element) {
      element.style.display = 'block';
    }

    function hide(element) {
      element.style.display = 'none';
    }
  }
}
